<template>
	<!-- MIF管理页面 -->
	<div class="mif-management">
		<!-- 页面标题 -->
		<div class="page-title">其它管理</div>

		<!-- 内容区域 -->
		<div class="content-wrapper">
			<!-- 操作栏：按钮 + 搜索区域 -->
			<div class="operation-bar">
				<div>
					<el-button size="small" type="primary" icon="el-icon-upload2" @click="handleImport" v-if="perms.includes('train:skill:other:import')">
						导入
					</el-button>
					<el-button size="small" type="primary" icon="el-icon-download" @click="handleExportTemp" v-if="perms.includes('train:skill:other:import')">
						下载模板
					</el-button>
					<el-button size="small" type="primary" icon="el-icon-download" @click="handleExport" v-if="perms.includes('train:skill:other:export')">
						导出
					</el-button>
					<input style="display: none" ref="uploadExcel" type="file" id="uploadExcel" @change="uploadHandle($event)" />
				</div>
				<div class="search-area">
					<label class="label">区域</label>
					<el-cascader
						size="small"
						v-model="selectedAreaIds"
						:options="areaList"
						:props="areaProps"
						placeholder="请选择区域"
						:show-all-levels="false"
						clearable
						collapse-tags></el-cascader>
					<label class="label ml10">公司名</label>
					<el-input size="small" placeholder="请输入公司" v-model="searchForm.agentName" clearable style="width: 200px"></el-input>
					<label class="label">姓名</label>
					<el-input
						size="small"
						v-model="searchForm.name"
						placeholder="请输入姓名"
						clearable
						style="width: 130px"
						@keyup.enter.native="handleSearch" />
					<el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch"></el-button>
					<el-button size="small" icon="el-icon-refresh" @click="handleReset"></el-button>
				</div>
			</div>

			<!-- 数据表格 -->
			<el-table
				v-loading="loading"
				:data="tableData"
				:row-class-name="tableRowClassName"
				:header-cell-style="{ color: '#444' }"
				border
				style="width: 100%">
				<el-table-column type="index" label="序号" width="60" align="center" />
				<el-table-column prop="userName" label="姓名" width="80" />
				<el-table-column prop="stuId" label="学员ID" width="80" />
				<el-table-column prop="agentName" label="公司名" min-width="100" />
				<el-table-column prop="areaName" label="省份" width="100" />
				<el-table-column prop="points" label="积分" width="60" />
				<el-table-column prop="fyActualScore" label="FY实操成绩" width="100" />
				<el-table-column prop="fyTheoryScore" label="FY理论成绩" width="100" />
				<el-table-column prop="evalScore" label="综合评价分" width="100" />
				<el-table-column prop="activeScore" label="能动分" width="80" />
				<el-table-column label="其它证书" width="100">
					<template slot-scope="scope">
						<div class="attach-file-list" v-for="value in scope.row.attachFileList">
							{{ value.fileName }}
							<i class="el-icon-download" @click="downloadFile(value)"></i>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleCertificate(scope.row)" v-if="perms.includes('train:skill:other:addCert')">
							证书管理
						</el-button>
						<el-button type="text" size="small" @click="handleEdit(scope.row)" v-if="perms.includes('train:skill:other:update')">编辑</el-button>
						<el-button type="text" size="small" class="danger-text" @click="handleDelete(scope.row)" v-if="perms.includes('train:skill:other:del')">
							删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="pagination-wrapper">
				<el-pagination
					background
					layout="total, sizes, prev, pager, next, jumper"
					:current-page="pageNum"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					:total="total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange" />
			</div>
		</div>

		<!-- 导入弹窗 -->
		<el-dialog
			:visible.sync="importDialogVisible"
			:show-close="false"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			class="role-dialog"
			width="450px">
			<span slot="title" class="dialog-title">
				<span>提示</span>
				<img src="@/assets/images/close.png" alt="" @click="importDialogVisible = false" />
			</span>
			<ul class="error-list">
				<li v-for="(item, i) in errorList" :key="i">{{ item }}</li>
			</ul>
		</el-dialog>
		<!-- 编辑 -->
		<OtherEditDialog ref="otherEditDialogRef" @refresh="getList" />
		<!-- 证书管理 -->
		<CertificateDialog ref="certificateDialogRef" @refresh="getList" />
	</div>
</template>

<script>
/**
 * MIF管理页面
 * 功能：MIF数据列表展示、搜索、导入、编辑、删除
 */
import { courseSkillScorePageList, courseSkillScoreDel, courseSkillMifUpdate, courseSkillScoreExport } from "@/api/skill";
import OtherEditDialog from "./components/OtherEditDialog.vue";
import CertificateDialog from "./components/CertificateDialog.vue";

export default {
	components: {
		OtherEditDialog,
		CertificateDialog,
	},
	data() {
		return {
			// 权限
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			// 搜索表单
			searchForm: {
				name: "",
				agentName: "",
			},
			// 区域
			selectedAreaIds: [],
			areaList: [],
			areaProps: {
				multiple: true,
				value: "id",
				label: "name",
				children: "areaList",
				emitPath: false,
				checkStrictly: false,
			},
			// 表格数据
			tableData: [],
			// 加载状态
			loading: false,
			// 分页参数
			pageNum: 1,
			pageSize: 10,
			total: 0,
			// 导入弹窗
			importDialogVisible: false,
			errorList: [],
			importLoading: false,
			importFile: null,
			// 编辑弹窗
			editDialogVisible: false,
			editLoading: false,
			editForm: {
				id: "",
				userId: "",
				name: "",
				mifs: 0,
			},
			editRules: {
				mifs: [{ required: true, message: "请输入MIFs", trigger: "blur" }],
			},
		};
	},

	created() {
		this.getList();
		this.getAreaData();
	},

	methods: {
		// 获取区域数据
		getAreaData() {
			let that = this;
			that.$request.post(
				"getListByCodesPerm",
				true,
				{
					codes: "areaType",
				},
				function (r) {
					if (r.code == "0") {
						that.areaList = r.data.areaType;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 导出
		handleExport() {
			courseSkillScoreExport(
				{
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					userName: this.searchForm.name,
					agentName: this.searchForm.agentName,
					areaIds: this.selectedAreaIds && this.selectedAreaIds.length > 0 ? this.selectedAreaIds.join(",") : "",
				},
				true,
			).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				const linkNode = document.createElement("a");
				linkNode.style.display = "none";
				linkNode.href = res.data;
				document.body.appendChild(linkNode);
				linkNode.click();
				URL.revokeObjectURL(linkNode.href);
				document.body.removeChild(linkNode);
			});
		},
		/**
		 * 获取MIF列表数据
		 */
		getList() {
			this.loading = true;
			// 调用API获取数据
			courseSkillScorePageList({
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				userName: this.searchForm.name,
				agentName: this.searchForm.agentName,
				areaIds: this.selectedAreaIds && this.selectedAreaIds.length > 0 ? this.selectedAreaIds.join(",") : "",
			})
				.then((res) => {
					this.tableData = res.data?.list || [];
					this.total = res.data?.totalCount || 0;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		/**
		 * 搜索
		 */
		handleSearch() {
			this.pageNum = 1;
			this.getList();
		},

		/**
		 * 重置搜索
		 */
		handleReset() {
			this.searchForm.name = "";
			this.searchForm.agentName = "";
			this.selectedAreaIds = [];
			this.handleSearch();
		},

		/**
		 * 分页大小变化
		 */
		handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},

		/**
		 * 页码变化
		 */
		handleCurrentChange(val) {
			this.pageNum = val;
			this.getList();
		},

		// 导入
		handleImport() {
			let el = document.getElementById("uploadExcel");
			el.click();
			this.uploadUrl = "courseSkillOtherImport";
		},

		// 上传
		uploadHandle(e) {
			let file = e.target.files[0];
			if (file) {
				if (window.sessionStorage.getItem("userInfo").superAdminFlag == "1" && file.size / 1024 / 1024 / 1024 > 1) {
					this.$message.error("导入文件不能大于1GB");
					return;
				}
				// 2022-07-31 应客户要求改为200M
				if (window.sessionStorage.getItem("userInfo").superAdminFlag != "1" && file.size / 1024 / 1024 > 200) {
					this.$message.error("导入文件不能大于200MB");
					return;
				}
				if (file.name.includes(".xlsx")) {
					let formdata = new FormData();
					formdata.append("file", file);
					let self = this;
					self.$request.initUploadExcel(formdata, self.uploadUrl, true).then((data) => {
						if (data.code == 0) {
							self.pageNo = 1;
							self.getList();
							if (data.data.length > 0) {
								self.importDialogVisible = true;
								self.errorList = data.data;
							} else {
								self.$message.success("导入成功");
							}
						}
					});
				} else {
					this.$message.error("文件格式不正确");
				}
			} else {
				this.$message.error("请选择上传的文件");
			}
			this.$refs.uploadExcel.value = "";
		},

		/**
		 * 编辑
		 */
		handleEdit(row) {
			this.$refs.otherEditDialogRef.init(row);
		},

		/**
		 * 确认编辑
		 */
		confirmEdit() {
			this.$refs.editForm.validate((valid) => {
				if (!valid) return;
				this.editLoading = true;
				// 调用编辑API
				courseSkillMifUpdate({
					id: this.editForm.id,
					mifs: this.editForm.mifs,
				})
					.then(() => {
						this.$message.success("编辑成功");
						this.editDialogVisible = false;
						this.getList();
					})
					.finally(() => {
						this.editLoading = false;
					});
			});
		},

		/**
		 * 删除
		 */
		handleDelete(row) {
			this.$confirm(`确认删除？`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					// 调用删除API
					courseSkillScoreDel({ id: row.id }).then(() => {
						this.$message.success("删除成功");
						this.getList();
					});
				})
				.catch(() => {});
		},
		/**
		 * 导出模板
		 */
		handleExportTemp() {
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = "/static/template/COURSE-SKILL-OTHER-TEMP.xlsx";
			linkNode.download = "COURSE-SKILL-OTHER-TEMP.xlsx";
			document.body.appendChild(linkNode);
			linkNode.click(); //模拟在按钮上的一次鼠标单击
			URL.revokeObjectURL(linkNode.href); // 释放URL 对象
			document.body.removeChild(linkNode);
		},
		// 证书管理
		handleCertificate(row) {
			this.$refs.certificateDialogRef.init(row);
		},
		// 下载证书
		downloadFile(row) {
			const fileLink = row.fileAddr;
			// 判断是否为图片格式，图片在新页面打开
			const imageExts = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
			const isImage = imageExts.some((ext) => fileLink.toLowerCase().endsWith(ext));
			if (isImage) {
				window.open(fileLink, "_blank");
				return;
			}
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = fileLink;
			linkNode.download = row.fileName;
			document.body.appendChild(linkNode);
			linkNode.click();
			URL.revokeObjectURL(linkNode.href);
			document.body.removeChild(linkNode);
		},
	},
};
</script>

<style lang="scss" scoped>
.mif-management {
	// 页面标题
	.page-title {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 20px;
	}

	// 内容区域
	.content-wrapper {
		background: #fff;
		border-radius: 8px;

		// 操作栏
		.operation-bar {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 15px;

			// 搜索区域
			.search-area {
				display: flex;
				align-items: center;
				gap: 10px;

				.label {
					font-size: 14px;
					color: #000000;
					white-space: nowrap;
					margin-left: 10px;
				}

				.ml10 {
					margin-left: 10px;
				}

				.el-button {
					font-size: 20px;
					padding: 5px;
					margin-left: 0;
					background-color: rgba(17, 127, 252, 0.2);
					color: #117ffc;
					border: none;
				}
			}
		}

		// 分页
		.pagination-wrapper {
			display: flex;
			justify-content: flex-end;
			margin-top: 20px;
		}

		// 危险文字按钮
		.danger-text {
			color: #f56c6c;
		}
	}
}

.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.error-list {
	height: 50vh;
	box-sizing: border-box;
	overflow: auto;

	li {
		list-style: none;
	}
}

.attach-file-list {
	i {
		font-size: 14px;
		cursor: pointer;
	}
}
</style>
